export default {
      id: "chevron-usage",
      viewBox: "0 0 14 22.34",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#chevron",
      toString: function () {
        return this.url;
      }
    }